module.exports = __webpack_public_path__ + "static/media/Rubik.35af6dbe.ttf";